import { render, staticRenderFns } from "./cash-delivery.vue?vue&type=template&id=d52e3bc6"
import script from "./cash-delivery.vue?vue&type=script&lang=js"
export * from "./cash-delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports